// French
export default  {
    homeScreen : {
        startConversation: 'Démarrer une conversation',
        newConversationButton: "OBTENIR DE L'AIDE",
        newMessageButton: '+ Nouveau message',
        allTopics: 'Tous les sujets',
        allChatsButton: 'Tout voir',
        poweredBy: 'Propulsé par Richpanel',
        reOpenConversation: 'Réouvrir une conversation',
        recentConversations: 'Conversations recentes',
        startAChat: 'Démarrer un chat',
        noRecentConversations: 'Pas de conversations récentes',
        noRecentOrders: 'Aucune commande récente',
        haveAQuestion: "Vous avez une question ou vous voulez simplement nous saluer ? Nous serions ravis de vous entendre.",
        conversationClosed: `Cette conversation est close. Si vous avez d'autres questions, veuillez réouvrir cette dernière.`,
        retry: 'Réessayez',
        errorOccured: "Une erreur s'est produite lors du traitement de votre demande.",
        successMessage: 'Nous avons reçu votre demande. Notre équipe vous répondra bientôt sur votre email',
        loadingMessage: "S'il vous plaît, attendez. Nous soumettons votre demande.",
        goHome: 'RENTRER CHEZ SOI',
        sendUsMessage: 'Envoyer un message',
        endChat: "TERMINER LE CHAT",
        goto: 'Aller à',
    },
    orderStatuses: {
        'completed': 'Terminé',
        'pending': 'En attente',
        'on hold': 'En cours',
        'processing': 'En traitement',
        'cancelled': 'Annulé',
        'fulfilled': 'Réalisé',
        'confirmed': 'Confirmé',
    },

    loginScreen: {
        title: 'Accéder à votre compte',
        titleForOrdersScreenForward: 'Connectez-vous pour voir les commandes',
        userIdFieldTitle: "Entrez votre telephone/e-mail pour obtenir de l’aide concernant votre commande.",
        userIdFieldPlaceHolder: "Entrez votre téléphone / adresse e-mail",
        sendCode: "ENTRER",
        enterCode: 'Entrez le code que nous avons envoyé à diane.la',
        enterTheCode: 'Entrer le code',
        notYourUserId: "Pas votre {userIdType}?",
        userIdTypes: {
            'phone': 'nombre',
            'email': 'email',
        },
        change: 'Changer',
        notReceivedCode: "Vous n’avez pas recu le code?",
        resendCode: 'Renvoyer',
        in: 'in',
        verifyCode: 'VÉRIFIER',
        logout: 'Se déconnecter',
        orderNumberFieldTitle: 'Entrez le numéro de commande pour le support de commande',
        orderNumberFieldPlaceholder: 'Entrez le numéro de commande Ex: 1234',
        zipcodeFieldTitle: "Code postal d'expédition",
        zipcodeFieldPlaceholder: "Entrez le code postal d'expédition",
        emailFieldTitle: 'Email',
        emailFieldPlaceholder: 'Entrez votre e-mail',
    },

    orderList : {
        reorder: 'Commander à nouveau',
        getHelp: "OBTENIR DE L'AIDE",
        startNewConversation: '+Nouveau message',
        viewPreviousOrder:'VOIR TOUTES LES COMMANDES',
        seeAll: 'Tout voir',
        viewMoreOrders: 'VIEW MORE ORDERS',
        viewOrderStatus: 'VOIR LE STATUT DE LA COMMANDE',
        chatWithUs: 'Discuter avec nous',
        issueWithPreviousOrder:'Aide sur les commandes précédentes' ,
        orderLabel: 'Commande',
        help: 'Aide',
        lastOrder: 'Dernière commande',
        selectRelevantItems: 'Sélectionnez les éléments pertinents',
        selectItemsErrorMsg: 'Please select items to proceed',
        selectAll: 'Tout sélectionner',
        selectQuantity: "Combien d'items ?",
        helpWithThisOrder: 'Aide concernant cette commande',
        yourOrders: 'Vos commandes',
        view: 'Voir',
        track: 'Suivre',
        addressTitle: 'Résumé de la commande',
        billingAddressTitle: 'Adresse de facturation',
        shippingAddressTitle: "Adresse d'expédition",
        receiptTitle: '{productCount} articles',
        itemTotal: 'Article au total',
        taxes: 'Taxes',
        discounts: 'Rabais', 
        giftCard: 'Gift Card', 
        deliveryCharges: 'Frais de livraison',
        total: 'Total',
        loginToViewOrders: 'Client existant?',
        loginSuggestion: "Bénéficiez d'une aide rapide et d'un support de commande",
        trackingOrderLabel: 'Track order',
        shipmentDescription: "Revenez sur cette page pour des mises à jour sur l'état de votre envoi",
        free: "gratuit",
        selectedItems: "Articles Sélectionnés",
        items: "Articles",
        "orderSearchPlaceholder": 'Filtrer par numéro de commande',
        "noOrderFound": 'Aucune commande correspondante {orderId}',
    },
    chatListScreen: {
        header: 'Vos conversations',
    },
    sentences: {
        "IN_A_DAY" : "L'équipe répond généralement en un jour.",
        "IN_FEW_MINUTES": "L'équipe répond généralement en quelques minutes.",
        "IN_FEW_HOURS": "L'équipe répond généralement en quelques heures.",
        "AS_SOON_AS_THEY_CAN": "L'équipe répondra dès que possible.",
        "BACK_ON": "Retour sur",
        "BACK_IN": "Retour à",
        "HOURS": "Heures",
        "MINUTES": 'Minutes',
        provideBelowDetails: "Veuillez fournir les détails ci-dessous",
    },
    inputFields: {
        submitted: 'Soumis'
    },
    inputPropDisplayNames: {
        "email": "Email",
        "phone": "Téléphone",
        "Phone": "Téléphone",
        "firstName": "Prénom",
        "lastName": "Nom",
        "uid": "Identifiant de l'utilisateur",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Téléphone pour la livraison",
        "source": "UTM Source",
        "lastOrderAt": "Last Order Time",
        "firstOrderAt": "First Order Time",
        "visits": "Session",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Vu pour la dernière fois",
        "createdAt": "Vu pour la première fois",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Email pour la facturation",
        "billingPhone": "Téléphone pour la facturation",
        "shippingEmail": "Email pour l'expédition",
        "state": "Etat",
        "city": "Ville",
        "country": "Pays",
        "deviceType": "Type d'appareil",
        "browserName": "Nom du navigateur",
        "osName": "Nom de l'OS",
        "platform": "Plate-forme",
        "ltv": "CLV",
        "ordersCount": "Orders Count",
        "name": "Nom",
        "RichpanelPredictedCLV": "Predicted CLV",
        "RichpanelAliveProbability": "Probabilité d'achat",
        "RichpanelNextOrderDate": "Date de la prochaine commande",
        "RichpanelPredictedOrderCount": "Nombre de commandes prévues",
        "aov": "AOV",
        "WebsiteURL":"URL du site web"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Etes-vous déjà client ?',
        YES_EXISITING_CUSTOMER: "Oui, je suis client",
        NO_EXISITING_CUSTOMER: "Non, je ne suis pas encore client",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Donnez à l'équipe un moyen de vous contacter.",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Vous serez averti ici et par e-mail ({email}) lorsqu'ils répondront.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Vous serez averti ici lorsqu'ils répondront.",
        LEAVE_YOUR_MESSAGE: "Veuillez écrire votre message ci-dessous.",
        TEAM_WILL_BE_BACK_IN:"L'équipe sera de retour dans {hours} heures",
        TEAM_WILL_BE_BACK_ON:"L'équipe sera de retour le {availableAt}",
        FEW_MORE_DETAILS: "Merci ! quelques détails supplémentaires nous aideront à vous attribuer la bonne personne:",
    },
    initialForm: {
        heading: 'Veuillez saisir vos coordonnées pour démarrer la conversation',
        startChat: 'Démarrer la conversation'
    },
    customerJourneyPreChatForm: {
        heading: 'Démarrer une discussion',
        startChat: 'Démarrer une discussion',
        proceed: 'Procéder',
        canWeHelpWithAnythingElse: 'Pouvons-nous aider avec autre chose?',
        noThanks: "Merci",
        yesContactSupport: "Oui, Chat avec support",
        contactSupport: "Contactez l'assistance",
        yes: 'Oui',
        no: 'Non',
    },
    rating: {
        askedHeader: 'Évaluez votre conversation',
        successHeader: 'Vous avez évalué cette conversation',
        thanksMessage: "Merci de nous avoir répondu",
        placeholderForRatingFeedback: "Veuillez écrire vos commentaires"
    },
    placeholders: {
        emojiSearch: 'Rechercher des Emojis',
        typeAMessage: 'Ecrire un message',
        searchGifs: 'Rechercher des GIF',
    },
    lastMessageText: {
        sentAGif: 'Envoyer un GIF',
        sharedFile: 'Partager un fichier',
        askedForQualificationDetails: 'Des détails ont été demandés',
        askedForRating: 'Une évaluation a été demandée',
        askedForFeedback: 'Un feedback a été demandé',
        sharedOrderSummary: "Recapitulatif de la commande partagé",
    },
    greetingAnimation: {
        weAreOnline: "Nous sommes en ligne",
        askUsAnything: "Demandez-nous n'importe quoi",
        chatWithUs: 'Discute avec nous',
    }
}